import { render, staticRenderFns } from "./CampaignMsgInfo.vue?vue&type=template&id=5c138485&"
import script from "./CampaignMsgInfo.vue?vue&type=script&lang=js&"
export * from "./CampaignMsgInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports